import PropTypes from 'prop-types';
import { useState } from 'react';

// material-ui
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

// assets
import { EditOutlined, LockOutlined, LogoutOutlined } from '@ant-design/icons';
import { Apps } from '@mui/icons-material';
import AddUser from 'pages/admin/addSystemUser';
import ResetAdminPassword from 'pages/admin/resetAdminPassword';
import { useSelector } from 'react-redux';
import { dispatch } from 'store';
import { login } from 'store/reducers/auth';
import utils from 'utils/utils';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

const ProfileTab = ({ handleLogout }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [openEditProfileDialog, setOpenEditProfileDialog] = useState(false);
  const [openResetPasswordDialog, setOpenResetPasswordDialog] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const { flavour } = useSelector((state) => state.auth);

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  const onSave = (payload) => {
    const token = { session: payload.sessionToken, refresh: payload.refreshToken };
    dispatch(login({ user: payload.user, token }));
    setOpenResetPasswordDialog(false);
    setOpenEditProfileDialog(false);
  };

  const handleOrderKeyClick = () => {
    const switchUrl = utils.getSwitchUrl(flavour);
    const app2Window = window.open(switchUrl, "_blank");
    if (app2Window) {
      setTimeout(() => {
        const token = utils.getTokensFromStorage();
        if (token && token.refresh) {
          app2Window.postMessage({ refreshToken: token.refresh, flavour: flavour }, "*");
        }
      }, 1000);
    }
  };

  return (
    <List component='nav' sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <ListItemButton
        selected={selectedIndex === 1}
        onClick={(e) => {
          handleListItemClick(e, 1);
          e.stopPropagation();
          handleOrderKeyClick();
        }}
      >
        <ListItemIcon>
          <Apps />
        </ListItemIcon>
        <ListItemText primary='Switch To APP CMS' />
      </ListItemButton>
      <ListItemButton
        selected={selectedIndex === 2}
        onClick={(e) => {
          handleListItemClick(e, 1);
          e.stopPropagation();
          setOpenEditProfileDialog(true);
        }}
      >
        <ListItemIcon>
          <EditOutlined />
        </ListItemIcon>
        <ListItemText primary='Edit Profile' />
      </ListItemButton>
      <ListItemButton
        selected={selectedIndex === 3}
        onClick={(e) => {
          handleListItemClick(e, 2);
          e.stopPropagation();
          setOpenResetPasswordDialog(true);
        }}
      >
        <ListItemIcon>
          <LockOutlined />
        </ListItemIcon>
        <ListItemText primary='Reset Password' />
      </ListItemButton>
      <ListItemButton selected={selectedIndex === 4} onClick={handleLogout}>
        <ListItemIcon>
          <LogoutOutlined />
        </ListItemIcon>
        <ListItemText primary='Logout' />
      </ListItemButton>
      {openResetPasswordDialog && (
        <ResetAdminPassword onCancel={() => setOpenResetPasswordDialog(false)} systemUser={user} onSave={onSave} />
      )}
      {openEditProfileDialog && <AddUser onCancel={() => setOpenEditProfileDialog(false)} user={user} onSave={onSave} page='editProfile' />}
    </List>
  );
};

ProfileTab.propTypes = {
  handleLogout: PropTypes.func
};

export default ProfileTab;